export const noteWidth = 30;
export const noteHeight = 5;
export const quarterInterval = 48;
export const verticalSizeNum = (num = 8) => quarterInterval * num;
export const editorHeight = quarterInterval * 8;
export const fps = 60;
export const longTapThreshold = 250;
export const divisors = [8, 16, 12, 24, 48, 32];

export const canvasMarginHorizontal = 50;
export const canvasMarginVertical = 25;

export const noteColors = ["#ff0000", "#0000ff", "#00cc00", "#ff9000"];
export const freezeColors = ["#ff4dd2", "#00ffff", "#ceff00", "#c99b7d"];
export const laneColors = ["#fff0ff", "#f0f0ff", "#f0fff0", "#fff0dd"];
